import styled from "styled-components";

const Label = styled.label`
  color: #fff !important;
`;

export { Label };
